import { render } from "./HighlightsPanel.vue?vue&type=template&id=608b1314&scoped=true"
import script from "./HighlightsPanel.vue?vue&type=script&lang=js"
export * from "./HighlightsPanel.vue?vue&type=script&lang=js"

import "./HighlightsPanel.vue?vue&type=style&index=0&id=608b1314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608b1314"]])

export default __exports__